// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`XsellProduct UI snapshot for product that can NOT be attached to sub 1`] = `
<div class="xsell-product">
  <div class="product xs-12 md-6">
    <div class="title xs-12 xs-mb-100m">
      <p class="upper bold xs-f-medium max-at-tweak">This is xsellMembershipDescription</p>
    </div>
    <div class="image xs-3"><img src="/image/url" alt="Image Alt Text"></div>
    <div class="info xs-8 xs-pl-100m">
      <div class="name">
        <p class="upper xs-f-medium max-at-tweak">Bolzano Brown</p>
      </div>
      <div class="prod-type xs-pt-25m xs-pb-25m">
        <p class="upper xs-f-xsmall max-at-tweak"></p>
      </div>
      <div class="description">This is short_description</div>
    </div>
  </div>
  <div class="ctas xs-12 md-6 xs-mt-150m md-mt-350m lg-mt-400m">
    <!----><button data-mr-ass="xsell-order-button" class="mr-btn btn-block xs-f-xsmall max-at-tweak add-to-cart">Add to Next Order</button></div>
</div>
`;

exports[`XsellProduct UI snapshot for product that can be attached to sub 1`] = `
<div class="xsell-product">
  <div class="product xs-12 md-6">
    <div class="title xs-12 xs-mb-100m">
      <p class="upper bold xs-f-medium max-at-tweak">This is xsellMembershipDescription</p>
    </div>
    <div class="image xs-3"><img src="/image/url" alt="Image Alt Text"></div>
    <div class="info xs-8 xs-pl-100m">
      <div class="name">
        <p class="upper xs-f-medium max-at-tweak">Bolzano Brown</p>
      </div>
      <div class="prod-type xs-pt-25m xs-pb-25m">
        <p class="upper xs-f-xsmall max-at-tweak"></p>
      </div>
      <div class="description">This is short_description</div>
    </div>
  </div>
  <div class="ctas xs-12 md-6">
    <div class="attachable-ctas xs-12">
      <productshipoptions-stub onetimeprice="24" subprice="22"></productshipoptions-stub>
    </div><button data-mr-ass="xsell-order-button" class="mr-btn btn-block xs-f-xsmall max-at-tweak add-to-cart">Add to Next Order</button>
  </div>
</div>
`;
